<template>
  <v-toolbar
    :fixed="fixedToolbar"
    :class="navToolbarScheme"
    :clipped-left="toolbarClippedLeft"
    app
  >
    <img src="/static/SecurytyNewLogo.png" height="60"/>
  </v-toolbar>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

